import useMealImageResolver from './useMealImageResolver';

const useMealImageToDisplay = meal => {
  const resolveMealImage = useMealImageResolver();

  return resolveMealImage(meal);
};

export default useMealImageToDisplay;
